import * as React from "react";
const SvgUnknown = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", contentScriptType: "text/ecmascript", ...props }, /* @__PURE__ */ React.createElement("ellipse", { cx: 32.542, cy: 31.729, fill: "none", stroke: "#00f", strokeDasharray: 5, rx: 25, ry: 15 }));
export default SvgUnknown;
